"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _ArrowDropDown = _interopRequireDefault(require("@mui/icons-material/ArrowDropDown"));
var _material = require("@mui/material");
var _SelectSorterModule = _interopRequireDefault(require("./SelectSorter.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SelectSorter = _ref => {
  let {
    label,
    currentOption,
    options,
    onChange
  } = _ref;
  const [anchorEl, setAnchorEl] = _react.default.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (_, _index, option) => {
    if (option) onChange(option);
    setAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _SelectSorterModule.default["select-sorter"]
  }, /*#__PURE__*/_react.default.createElement("label", null, label), /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "basic-button",
    "aria-controls": open ? "basic-menu" : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? "true" : undefined,
    endIcon: /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null),
    onClick: handleClick,
    sx: {
      textTransform: "none",
      fontSize: "1rem",
      fontWeight: "400"
    }
  }, currentOption.label), /*#__PURE__*/_react.default.createElement(_material.Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    slotProps: {
      list: {
        "aria-labelledby": "basic-button"
      }
    },
    disablePortal: false,
    container: () => document.body,
    disableScrollLock: true
  }, options.map(option => /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
    key: option.key,
    onClick: event => handleClose(event, undefined, option)
  }, option.label))));
};
var _default = exports.default = SelectSorter;